export enum KEYS {
	TRACK_ID = 'trackId',
	ACCESS_TOKEN = 'accessToken',
	IDEMPOTENCY_KEY = 'authIdempotencyKey'
}
